import { CtaLink } from '@purpur/library';
import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const ProductLoginCtaContainer = styled.section`
    background: ${getPurpurColor('backgroundToneOnToneSecondary')};
    border-radius: ${getPurpurBorder('radiusMd')};
    margin-top: ${getPurpurSpacing('600')};
    margin-bottom: ${getPurpurSpacing('400')};
    padding: ${getPurpurSpacing('250')} ${getPurpurSpacing('200')};

    ${purpurMedia('lg')`
        margin-bottom: ${getPurpurSpacing('600')};
        padding: ${getPurpurSpacing('300')};
    `}
`;

export const TitleRow = styled.h3`
    display: flex;
    gap: ${getPurpurSpacing('100')};
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightBold')};
    margin: 0;
`;

export const BenefitsList = styled.ul`
    list-style: disc;
    padding-left: ${getPurpurSpacing('300')};
    margin: ${getPurpurSpacing('200')} 0 ${getPurpurSpacing('250')};
`;

export const BenefitItem = styled.li`
    & + & {
        margin-top: ${getPurpurSpacing('150')};

        ${purpurMedia('lg')`
            margin-top: ${getPurpurSpacing('100')};
        `}
    }
`;

export const LoginLink = styled(CtaLink)`
    ${purpurMedia('lg')`
        max-width: 11.5rem;
    `}
`;
